import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './FlexContainer.scss';

const FlexContainer = ({
  children,
  className,
}) => (
  <div className={cx('flex-container', className)}>
    <div className="flex-container__content">
      {children}
    </div>
  </div>
);

FlexContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FlexContainer.defaultProps = {
  className: '',
};

export default FlexContainer;



// WEBPACK FOOTER //
// ./src/common/components/FlexContainer/FlexContainer.js